var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDef(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "10px",
    viewBox: "0 0 17 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF3BTest-v2---Lucie",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Devis->-Edition",
    transform: "translate(-1373.000000, -756.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Data-Tabel-Mes-Devis",
    transform: "translate(271.000000, 671.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Demandes-Data-Table",
    transform: "translate(8.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line/1",
    transform: "translate(14.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1046.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7258759,5.16112207 C34.4707739,5.4162241 34.4707739,5.8298262 34.7258759,6.08492822 L42.2970697,13.6561221 L42.2970697,13.6561221 C42.5554252,13.9032447 42.9625204,13.9032447 43.2208759,13.6561221 L43.2208759,13.6561221 L43.2208759,13.6561221 L50.7920697,6.08492822 C51.0471718,5.8298262 51.0471718,5.4162241 50.7920697,5.16112207 C50.5369677,4.90602005 50.1233656,4.90602005 49.8682636,5.16112207 L42.7589728,12.2704129 L42.7589728,12.2704129 L35.649682,5.16112207 C35.39458,4.90602005 34.9809779,4.90602005 34.7258759,5.16112207 Z",
    id: "Path",
    transform: "translate(42.758973, 9.398581) scale(1, -1) translate(-42.758973, -9.398581) "
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDef);
export default __webpack_public_path__ + "static/media/arrow-def.bc6ea6e09694d99773d7cfde99bb5e82.svg";
export { ForwardRef as ReactComponent };